import "animate.css";
import { Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import { Link } from "react-router-dom";
import { Element, Events, scrollSpy } from "react-scroll";

import { academicYears, getPagePayload } from "years";
import { getVisitorCounts, updateVisitorCounts } from "core/util/visitorCounts";

import LoadingSpin from "components/Loading";
import ViewSelect from "components/ViewSelect";
import YearSelect from "components/YearSelect";

import homeTopBG from "assets/images/gif/home-fg.gif";
import homeTopMobile from "assets/images/gif/SUT_freshmen-mobile-Animate.gif";
import homeBG from "assets/images/jpg/home_bg.jpg";
import stuView from "assets/images/png/student_comp-01.png";
import homeTopMobileBG from "assets/images/png/SUT_freshmen-mobile-bg.png";
import titleIcon1 from "assets/images/png/title-main-1.png";
import logo from "assets/images/svg/logo.svg";

import {
  BgTop,
  Block,
  BlockName,
  BlockNext,
  BoxImage,
  Container,
  DetailHome,
  FixBoxLayout,
  SubHead,
  TextDetail,
  TextName,
  TitleHome,
  View,
} from "./home.style";

const HomePage = ({ selectYear, year }) => {
  const [section, setSection] = useState({
    first: {},
    secondary: {},
  });
  const [view, setView] = useState({
    viewAll: 0,
    viewOfYear: 0,
  });
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    Events.scrollEvent.register("begin", function (to, element) {
      // console.log('begin', arguments)
    });

    Events.scrollEvent.register("end", function (to, element) {
      // console.log('end', arguments)
    });
    scrollSpy.update();
    return () => {
      Events.scrollEvent.remove("begin");
      Events.scrollEvent.remove("end");
    };
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
  }, []);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    getDataHome();
  }, [year]);

  const getView = async (selectedYear) => {
    const response = { data: getPagePayload(selectedYear, "home") };
    const visitorCounts = await getVisitorCounts({
      scope: "site",
      year: selectedYear,
    });

    if (response?.data?.code === 200) {
      const data = response?.data?.data;

      setView({
        viewAll: visitorCounts?.visitor ?? data?.visitor,
        viewOfYear: visitorCounts?.visitor_of_year ?? data?.visitor_of_year,
      });
    } else {
      setView({ viewOfYear: 0, viewAll: 0 });
    }
  };

  const getDataHome = async () => {
    setIsLoading(false);
    const response = { data: getPagePayload(year, "home") };
    const visitorCounts =
      (await updateVisitorCounts({
        scope: "site",
        year,
      })) ||
      (await getVisitorCounts({
        scope: "site",
        year,
      }));

    if (response?.data?.code === 200) {
      const data = response?.data?.data;
      const dataSection = data?.section.map((item) => ({
        content: item?.content,
        title: item?.title,
        media: item?.media,
      }));
      setIsLoading(true);
      setSection({
        first: dataSection[0],
        secondary: dataSection[1],
      });
      setView({
        viewAll: visitorCounts?.visitor ?? data?.visitor,
        viewOfYear: visitorCounts?.visitor_of_year ?? data?.visitor_of_year,
      });
    } else {
      setIsLoading(true);
      setSection({ first: {}, secondary: {} });
      setView({ viewOfYear: 0, viewAll: 0 });
    }
  };

  return (
    <>
      <Container>
        {isLoading ? (
          <>
            <Block src={windowWidth <= 768 ? homeTopMobileBG : homeBG}>
              <BgTop src={windowWidth < 414 ? homeTopMobile : homeTopBG} />

              <Row className="row-center">
                <Col span={24}>
                  {windowWidth <= 414 && (
                    <Link to="/">
                      <img
                        loading="lazy"
                        onClick={() => window.scrollTo(0, 0)}
                        src={logo}
                        alt="logo header"
                        style={{
                          width: "100%",
                          maxHeight: "100px",
                          padding: "0 10px",
                          marginBottom: "40px",
                        }}
                      />
                    </Link>
                  )}

                  <TitleHome className="animate__animated animate__fadeInDown animate__slow">
                    {section?.first?.title
                      ? section?.first?.title
                      : "เราจะอยู่เป็นเพื่อนน้อง ๆ ตลอดปีการศึกษา"}
                  </TitleHome>
                </Col>
                <Col span={24}>
                  <DetailHome className="animate__animated animate__fadeInUp animate__slow">
                    {section?.first?.content
                      ? section?.first?.content
                      : "เว็บไซต์คู่มือสำหรับน้อง ๆ มทส. ปี 1 ทุกคำตอบของคำถามรวมอยู่ที่นี่"}
                  </DetailHome>
                </Col>

                <BlockNext>
                  <BoxImage className="icon-next">
                    <div
                      className="layout-footer"
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        gap: "10px",
                      }}
                    >
                      <YearSelect
                        onChange={selectYear && selectYear}
                        year={year}
                        item={academicYears.map(({ ce, label }) => ({
                          value: ce,
                          label,
                        }))}
                      />

                      <Link
                        style={{ display: "flex", justifyContent: "center" }}
                        to="/course-introduction"
                      >
                        <p>อ่านคู่มือ</p>
                      </Link>
                    </div>
                  </BoxImage>
                </BlockNext>
              </Row>
            </Block>

            {section?.secondary?.link && (
              <Element name="sut-presidnt">
                <Row align="top" className="row-name">
                  <Col span={10}>
                    <BlockName>
                      <img src={titleIcon1} alt="icon title" loading="lazy" />

                      <TextName>
                        {section?.secondary?.title
                          ? section?.secondary?.title
                          : "สารจากอธิการบดี"}
                      </TextName>
                    </BlockName>
                  </Col>
                  <Col span={14}>
                    <TextDetail className="animate__animated animate__zoomInLeft animate__slow">
                      {section?.secondary?.content
                        ? section?.secondary?.content
                        : "Lorem Ipsum is simply dummy text of the printing and typesettingindustry. Lorem Ipsum has been the industry’s standard dummytext ever since the 1500s, when an unknown printer took a galleyof type and scrambled it to make a type specimen book. It hassurvived not only five centuries, but also the leap intoelectronic typesetting, remaining essentially unchanged. It waspopularised in the 1960s with the release of Letraset sheetscontaining Lorem Ipsum passages, and more recently with desktoppublishing software like Aldus PageMaker including versions ofLorem Ipsum."}
                    </TextDetail>
                  </Col>
                </Row>

                <Row
                  style={{
                    height: "1078px",
                    background: "#72DBF4",
                    color: "black",
                    width: "100%",
                  }}
                >
                  <Col span={24}>vidio</Col>
                </Row>
              </Element>
            )}

            <FixBoxLayout bg="#FFF8E6">
              <div className="layout-view">
                <Row className="row-group" style={{ alignItems: "center" }}>
                  <Col span={6}>
                    <img
                      loading="lazy"
                      src={stuView}
                      style={{ width: "100%", maxWidth: "460px" }}
                      alt="student view"
                    />
                  </Col>
                  <Col offset={1} span={17}>
                    <div style={{ maxwWidth: "450px" }}>
                      <SubHead weight="bold">
                        คู่มือของเรามียอดเข้าชมมาแล้ว
                      </SubHead>
                      <Row className="row-view">
                        <Col span={12}>
                          <SubHead>ตั้งแต่เริ่มเปิดเว็บไซต์</SubHead>
                          <View>
                            <CountUp
                              start={0}
                              end={view?.viewAll}
                              duration={2}
                              useEasing={true}
                              useGrouping={true}
                              separator=","
                              decimals={0}
                              decimal=","
                            />
                          </View>
                          <SubHead>ครั้ง</SubHead>
                        </Col>
                        <Col span={12}>
                          <div
                            style={{
                              display: "flex",
                              gap: "20px",
                            }}
                          >
                            <SubHead align="center">ปี (พ.ศ.)</SubHead>
                            <ViewSelect
                              year={year}
                              background="#fff9ea"
                              onChange={(value) => getView(value)}
                            />
                          </div>

                          <View>
                            <CountUp
                              start={0}
                              end={view?.viewOfYear}
                              duration={2}
                              useEasing={true}
                              useGrouping={true}
                              separator=","
                              decimals={0}
                              decimal=","
                            />
                          </View>
                          <SubHead>ครั้ง</SubHead>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </FixBoxLayout>
          </>
        ) : (
          <LoadingSpin />
        )}
      </Container>
    </>
  );
};

export default HomePage;
